import React, { useContext, useEffect, useState } from 'react'
import Keyboard from 'react-simple-keyboard'
import { MathFieldContext } from './mathInput/mathfieldContext'
import $ from 'jquery'

function SymbolicKeyboard({
  keyboard,
  symbolLayout,
  onChange,
  onKeyPress,
  display,
}) {
  const mathfield = useContext(MathFieldContext)

  useEffect(() => {
    if (mathfield && typeof mathfield.focus === 'function') {
      $(`#mq-keyboard-def-${mathfield.id}`).css('bottom', `0px`)
    }
  }, [mathfield])

  const onMouseDown = (e) => {
    if (e.target instanceof HTMLElement && e.target.nodeName !== 'SELECT') {
      e.preventDefault()
      if (mathfield && typeof mathfield.focus === 'function') {
        mathfield.focus()
      }
    }
  }
  return (
    <React.Fragment>
      <div
        id={`mq-keyboard-sym-${mathfield.id}`}
        onMouseDown={onMouseDown}
        className="col-span-1 sm:col-span-1 lg:col-span-1 bg-white -me-[40px] ms-[0px] w-full"
      >
        <Keyboard
          baseClass={'bg-white'}
          keyboardRef={(r) => (keyboard.current = r)}
          layout={symbolLayout}
          onChange={onChange}
          onKeyPress={onKeyPress}
          display={display}
          // theme="hg-layout-custom"
          physicalKeyboardHighlight={true}
          syncInstanceInputs={false}
          mergeDisplay={true}
          debug={false}
          buttonTheme={[
            {
              class: 'bg-[#717BBC]',
              buttons: '÷ x ÷ - = +',
            },

            {
              class: 'border-[1px] border-v8-line pb-2',
              buttons: '÷ s1 s2 s3 s4 x < > (□) s6 ÷ ≤ ≥ &#8730 % + - = ± π s5',
            },
            // {
            //   class: `bg-['/images/a.png']`,
            //   buttons: ' ',
            // },

            {
              class: 'text-white',
              buttons: '+ x ÷ - = ÷',
            },
            {
              class: `bg-[url('/images/s1.png')] bg-no-repeat bg-center v-none`,
              buttons: 's1',
              // display: '^{}',
            },
            {
              class: `bg-[url('/images/s2.png')] bg-no-repeat bg-center v-none`,
              buttons: 's2',
            },
            {
              class: `bg-[url('/images/s3.png')] bg-no-repeat bg-center v-none`,
              buttons: 's3',
            },
            {
              class: `bg-[url('/images/s4.png')] bg-no-repeat bg-center v-none`,
              buttons: 's4',
            },
            {
              class: `bg-[url('/images/sqaure.png')] bg-no-repeat bg-center v-none`,
              buttons: '&#8730',
            },
            {
              class: `bg-[url('/images/pi.png')] bg-no-repeat bg-center v-none`,
              buttons: 'π',
            },
            {
              class: `bg-[url('/images/s5.png')] bg-no-repeat bg-center v-none`,
              buttons: 's5',
            },
            {
              class: `bg-[url('/images/I19.png')] bg-no-repeat bg-center v-none`,
              buttons: 's6',
            },
          ]}
        />
      </div>
    </React.Fragment>
  )
}

export default SymbolicKeyboard
